export enum SortOrder {
  Ascending = "Ascending",
  Descending = "Descending",
}
